import React, { useState, useEffect } from "react";
import styles from "./header.module.css";
import logo from "../../../images/_finais/header-logo_compress.webp";
import mobileLogo from "../../../images/_finais/menu-item-logo_compress.webp";
import emailIcon from "../../../images/_finais/icon_email_compress.webp";
import linkedinIcon from "../../../images/_finais/icon_linkedin_compress.webp";
import MenuBar from "../MenuBar/menu-bar";
import SubHeaderInfo from "../SubHeaderInfo/sub-header-info";

interface IProps {
  page: any;
  onHandlePages: any;
}

const Header = ({ page, onHandlePages }: IProps) => {
  const menuItems = [
    { mobileLabel: "Home", label: "HOME", url: "/" },
    { mobileLabel: "Sobre", label: "SOBRE", url: "/sobre" },
    { mobileLabel: "Produtos", label: "PRODUTOS", url: "/produtos" },
    { mobileLabel: "Equipe", label: "EQUIPE", url: "/equipe" },
    { mobileLabel: "Clientes", label: "CLIENTES", url: "/clientes" },
    { mobileLabel: "Insights", label: "INSIGHTS", url: "/insights" },
    { mobileLabel: "Contato", label: "CONTATO", url: "/contato" },
  ];

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <header className={styles.header}>
        <div className={styles.logo_div}>
          {width >= 480 ? (
            <img className={styles.logo} src={logo} alt="Logo TruEvidence" />
          ) : (
            <img
              className={styles.mobileLogo}
              src={mobileLogo}
              alt="Logo TruEvidence"
              loading="lazy"
            />
          )}
        </div>
        <div className={styles.line} />
        <MenuBar items={menuItems} page={page} onHandlePages={onHandlePages} />
      </header>
      <div className={styles.green_bar}>
        <SubHeaderInfo
          alt="email"
          textInfo="contato@truevidence.com.br"
          icon={emailIcon}
        />
        <SubHeaderInfo
          alt="linkedin"
          textInfo="linkedin.com/in/truevidence"
          icon={linkedinIcon}
        />
      </div>
    </>
  );
};

export default Header;
